import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';

@customElement('visual-solar-location')
export class VisualSolarLocation extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}

		.container {
			width: 100%;
		}

		.defaultLocation {
			width: 100%;
		}

	`;

	render() {
		return html`
			<div class="container">
				<img class="defaultLocation" src="/line-assets/img/earth.jpg"/>
			</div>
		`;
	}
}
